var MachineRegistrationBase = /** @class */ (function () {
    function MachineRegistrationBase() {
        this.machineRegistrationData = new MachineRegistrationData();
        this.registrationData = new RegistrationData();
    }
    return MachineRegistrationBase;
}());
export { MachineRegistrationBase };
var MachineRegistrationData = /** @class */ (function () {
    function MachineRegistrationData() {
        this.serialNumber = null;
        this.machineModel = null;
        this.purchaseDate = new Date();
        this.storeName = null;
        this.isInstalledSmartLink = false;
        this.isActivatedSmartLink = false;
        this.serialNumberSmartLink = null;
        this.imeiSmartLink = null;
        this.startUpDate = null;
        this.nonce = null;
        this.tempAttachmentId = null;
    }
    return MachineRegistrationData;
}());
export { MachineRegistrationData };
var RegistrationData = /** @class */ (function () {
    function RegistrationData() {
        this.customerName = null;
        this.customerStreet = null;
        this.customerCity = null;
        this.customerZipCode = null;
        this.customerState = null;
        this.customerCountry = null;
        this.isSameAddress = true;
        this.installedStreet = null;
        this.installedCity = null;
        this.installedZipCode = null;
        this.installedState = null;
        this.installedCountry = null;
        this.email = null;
        this.phoneNumber = null;
    }
    return RegistrationData;
}());
export { RegistrationData };
